import { render } from "./EventCreate.vue?vue&type=template&id=50003f46"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"
script.render = render

export default script